import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from "material-ui/styles/getMuiTheme";
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import DropDownArrow from 'material-ui/svg-icons/navigation/arrow-drop-down'

import portalTheme from "../../../themes/portalTheme";

import cx from 'classnames';
import s from '../FormElement.css';


class PortalSelectField extends Component {
  static propTypes = {
    ariaLabel: PropTypes.string,
    className: PropTypes.string,
    description: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    errorText: PropTypes.node,
    fullWidth: PropTypes.bool,
    label: PropTypes.node,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    options: PropTypes.array.isRequired,
    required: PropTypes.bool,
    value: PropTypes.any,
  };

  timerId = null;

  componentDidMount() {
    this.setAriaLabelOnArrowButton();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ariaLabel !== this.props.ariaLabel ||
        prevProps.name !== this.props.name ||
        prevProps.id !== this.props.id) {
      this.setAriaLabelOnArrowButton();
    }
  }

  componentWillUnmount() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  }

  setAriaLabelOnArrowButton = () => {
    const { id, ariaLabel, name } = this.props;
    this.timerId = setTimeout(() => {
      let selectFieldContainer = document.getElementById(id);
      if (selectFieldContainer && selectFieldContainer.parentElement) {
        let arrowButton = selectFieldContainer.parentElement.querySelector('button');
        if (arrowButton) {
          arrowButton.setAttribute('aria-label', (ariaLabel || name || 'select') + ' dropdown');
        }
      }
    }, 0);
  };

  render() {
    const {
      className, description, disabled, id, errorText, fullWidth,
      label, name, onChange, options, required, value, onBlur,
    } = this.props;

    return (
      <div className={cx(s.component, className, {[`${s.disabled}`]: disabled})}>
        <MuiThemeProvider muiTheme={getMuiTheme(portalTheme)}>
          <SelectField
            className={s.input}
            disabled={disabled}
            errorText={errorText}
            errorStyle={{color:'#B2120B'}}
            id={id}
            title={name}
            iconStyle={{fill:'#222222'}}
            dropDownMenuProps={{
              iconButton: <DropDownArrow aria-hidden="true" style={{fill:'#222222'}} />,
            }}
            floatingLabelText={label}
            floatingLabelStyle={{color:'#222222'}}
            selectedMenuItemStyle={{color:'#277B7C'}}
            fullWidth={fullWidth}
            name={name}
            onChange={(event, index, payload) => { if (onChange) onChange(event, payload) }}
            required={required}
            value={value}
            onBlur={onBlur}
          >

            {options.map((option, index) => (
              <MenuItem key={`${id}__${index}`}
                id={`${id}__${index}`}
                title={option}
                primaryText={option}
                value={option} />
            ))}
          </SelectField>
        </MuiThemeProvider>

        {description &&
          <label className={cx(s.description, {[`${s.moveDown}`]: errorText})}>{description}</label>
        }
      </div>
    );
  }
}

export default PortalSelectField;



// WEBPACK FOOTER //
// ./src/components/FormElements/PortalSelectField/PortalSelectField.js